import * as Sentry from '@sentry/react';

export function initSentry() {
  const dsn = document.querySelector<HTMLMetaElement>('meta[name="sentry-dsn"]')?.content;
  if (!dsn) return;

  const release = document.querySelector<HTMLMetaElement>('meta[name="sentry-release"]')?.content || undefined;

  Sentry.init({
    dsn,
    release,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    // Environment noise from in-app browsers / native WebViews that isn't our code:
    // - "Java object is gone": Android WebView (Facebook/Instagram in-app browser)
    //   whose injected JS bridge got garbage-collected mid-navigation (BJJ-E, BJJ-F).
    // - webkit.messageHandlers undefined: iOS WKWebView bridge probing (BJJ-J).
    // - IndexedDB "connection is closing": Firebase Auth persistence during unload (BJJ-H).
    ignoreErrors: [
      /Java object is gone/i,
      /webkit\.messageHandlers/i,
      /The database connection is closing/i,
    ],
  });
}
